import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Heart, ArrowRight } from 'lucide-react';
import { useWishlist } from '../context/WishlistContext';
import ProductCard from '../components/ProductCard';

const WishlistPage = () => {
  const { wishlist } = useWishlist();

  if (wishlist.length === 0) {
    return (
      <div className="min-h-screen pt-24 flex items-center justify-center" data-testid="empty-wishlist">
        <div className="text-center">
          <Heart size={64} className="text-foreground/20 mx-auto mb-6" />
          <h1 className="font-heading text-3xl mb-4">Votre liste de favoris est vide</h1>
          <p className="text-foreground/60 mb-8">Ajoutez des pièces que vous aimez pour les retrouver facilement</p>
          <Link to="/shop" className="btn-primary inline-flex items-center gap-2">
            Découvrir la collection
            <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-24 pb-16" data-testid="wishlist-page">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="py-12 border-b border-black/10 mb-12">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="font-heading text-4xl md:text-6xl tracking-tight"
          >
            Favoris
          </motion.h1>
          <p className="text-foreground/60 mt-4">{wishlist.length} article{wishlist.length !== 1 ? 's' : ''}</p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
          {wishlist.map((product, index) => (
            <ProductCard key={product.id} product={product} index={index} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default WishlistPage;
